class Api {
  constructor() {
    this.cookies = {
      PROPERTIES: 1010,
      PROPERTY: 1011,
      POWER: 1012,
      GUEST: 1013,
      SOURCE: 1014,
      APPS: 1015,
      APP: 1016,
      USERINPUTS: 1017,
      PLAY: 1030,
      STOP: 1031,
      AUDIO: 1032,
      SUBTITLE: 1033,
      STATUS: 1034
    }
  }

  _init = async () => {
    window.actionTimeout = 60000
    document.getElementById("viewport").setAttribute("content", "width=1280, initial-scale=1.5, user-scalable=no")

    await this.loadResources()
    await _$.sleep(2000)
    await this.makeConfigurations()

    this.addListeners()
    return true
  }

  addListeners = () => {
    wixpObject.WebIXPOnReceive = this._eventHandler

    _$.vue.$on("mediaPlaying", () => !__.device.isPowerOn() && __.media.stop().then(() => __.media.request(true)))

    _$.vue.$on("standBy", () => __.platform.go().then(() => __.media.request(true)))
    _$.vue.$on("powerOn", () => __.media.request())

    //wixpObject.WebIXPOnReceiveRawData = this.WIXPCallbackRawDataReceived
  }

  WIXPCallbackRawDataReceived = RawData => {
    try {
      console.log("Raw Data Received from the Server = " + RawData)
    } catch (E) {
      console.log(E)
    }
  }

  makeConfigurations = async () => {
    return true
  }
  loadResources = async () => {
    _$.loader.createObject("object", {
      style: "visibility: hidden;",
      type: "application/jswebixp",
      width: "0",
      height: "0",
      id: "wixpObject"
    })
    return true
  }
  _eventHandler(WIXPResponseJSON) {
    try {
      console.log(WIXPResponseJSON)
      WIXPResponseJSON = JSON.parse(WIXPResponseJSON)

      const event_ = {
        error: WIXPResponseJSON.Fun === "Error",
        type: WIXPResponseJSON.Fun,
        cookie: WIXPResponseJSON.Cookie,
        detail: WIXPResponseJSON.Fun === "Error" ? WIXPResponseJSON.CommandDetails.FunCausedError : WIXPResponseJSON.CommandDetails
      }
      return _$.handler.emit(event_)
    } catch (e) {
      return _$.error(e)
    }
  }
  _sendCommand(command, Svc = "WIXP") {
    let command_ = {
      Svc: Svc,
      SvcVer: "4.0",
      Cookie: 222
    }

    command_ = Object.assign(command_, command)
    wixpObject.WebIxpSend(JSON.stringify(command_))
  }
}

export default Api
